import { render, staticRenderFns } from "./ModalForwardProtocol.vue?vue&type=template&id=b2ff7cfe&scoped=true&"
import script from "./ModalForwardProtocol.vue?vue&type=script&lang=js&"
export * from "./ModalForwardProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ff7cfe",
  null
  
)

export default component.exports